import {Component, OnDestroy} from '@angular/core';
import {ICellEditorAngularComp} from 'ag-grid-angular';
import {ICellEditorParams} from 'ag-grid-community';
import {Store} from '@ngrx/store';
import {selectLineColours as ngpLineColour} from '../../../../features/ngp-report/store/ngp-report.selectors';
import {GridUtils} from '../../../../shared-utilities/utils-old/grid-utils-old/grid-utils';
import {Observable, Subject} from 'rxjs';
import {
  selectLineColours as stockManagerLineColour,
} from '../../../../features/stock-manager/store/stock-manager.selectors';
import {selectCurrentNavigationPage} from '../../../../features/user-access/user-stores-store/user-store.selectors';
import {take, takeUntil} from 'rxjs/operators';
import {IconsEnum} from '../../../shared-icons/models/icons.enum';
import {TLineColour} from '../../../../features/settings-new/models';

@Component({
  selector: 'app-cell-renderer-line-color',
  templateUrl: './cell-renderer-line-color.component.html',
  styleUrls: ['./cell-renderer-line-color.component.scss'],
  standalone: false,
})
export class CellRendererLineColorComponent implements ICellEditorAngularComp, OnDestroy {
  value: string;
  params: ICellEditorParams;
  width: number;
  colDefField: string;
  lineColourObj: TLineColour;
  currentPage$: Observable<string>;
  currentPage: string;
  protected readonly icons = IconsEnum;
  private destroy$ = new Subject<boolean>();

  constructor(
    private readonly store: Store,
  ) {
  }

  agInit(params: ICellEditorParams): void {
    this.currentPage$ = this.store.select(selectCurrentNavigationPage);
    this.currentPage$.pipe(take(1)).subscribe((page: string) => {
      this.currentPage = page;
    });
    this.params = params;
    this.colDefField = params.colDef.field;
    this.value = this.params.data[this.colDefField];
    this.width = this.params.colDef.width;
    if (this.currentPage === 'ngp-report') {
      this.store.select(ngpLineColour).pipe(takeUntil(this.destroy$)).subscribe((lineColours: TLineColour): void => {
        this.lineColourObj = {...lineColours};
      });
    } else {
      this.store.select(stockManagerLineColour).pipe(takeUntil(this.destroy$)).subscribe((lineColours: TLineColour): void => {
        this.lineColourObj = {...lineColours};
      });
    }

  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }


  getValue(): string {
    return this.value;
  }

  onUndoChangesClick(): void {
    this.params = {...this.params};
    this.params.data = structuredClone(this.params.data);
    this.value = this.params.data.originalValue[this.colDefField].value;
    this.params.data[this.colDefField] = this.params.data.originalValue[this.colDefField].value;
    GridUtils.removeIsEditingFlagAndDispatch(this.params.data, this.params.colDef.field, this.store, this.currentPage);
    GridUtils.updateIsEditedAndForceRefresh(this.params);
  }

}
